module.exports = __webpack_public_path__ + "static/media/dma.dd0eb2ca.svg";